import { Button } from 'components-antd';

import styles from './styles.module.scss';

import { FormsTableStatus } from 'app-constants';
import classNames from 'classnames';

export const VoidFormButton = (props) => {
  const { formDetails, disableSections, selectedFormStatus, changeModalDetails, isTeamOwner } =
    props;

  const isDraftForm = selectedFormStatus === FormsTableStatus.Draft;
  const isWaitingOnOtherForm = selectedFormStatus === FormsTableStatus.WaitingOnOthers;

  const isFormCreator = formDetails?.isOwner;

  const onVoidClick = () => {
    changeModalDetails({
      modalType: 'confirmation',
      formName: formDetails?.formName,
    });
  };

  if (
    formDetails?.isCompleted ||
    formDetails?.isCancelled ||
    ((isDraftForm || isWaitingOnOtherForm) && !isFormCreator && !isTeamOwner)
  )
    return null;

  return (
    <div className={styles.buttonWrapper}>
      <Button
        variant="default"
        disabled={!formDetails || disableSections}
        className={classNames(styles.voidButton, { [styles.disabledSection]: disableSections })}
        onClick={onVoidClick}
      >
        Void
      </Button>
    </div>
  );
};
